import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

const Home = () => {

    const [showOptions, setShowOptions] = useState(false);
    const [selectedOption, setSelectedOption] = useState("レギュラーモデル");
    const handleShowOptions = () => {
        setShowOptions(!showOptions);
    }
    const navigate = useNavigate();
    const navigateTo = () => {
        navigate('/check')
    }
    return (

        <div className="row main-box">
            <div className="col-md-6 image-box">
                <div><img src="img/hardware_image.png" alt="hardware_image" className="main-image" /></div>
            </div>

            <div className="col-md-6 detail-box">
                <div className="top-box">
                    <div className="logo-box">
                        <img src="img/logo.png" alt="logo" className="logo" />
                    </div>
                    <div className="info-box">
                        <span className="big-text">ハードウェアテストアプリ</span>
                        {showOptions && <div>
                            <div className="info-text"><img src="img/info.png" alt="info" />すべての接続を確認し、自己ハードウェア
                                テストに必要な準備を確認してください。</div>
                            <div className="options-box mt-5">
                                <label>
                                    <input
                                        type="radio"
                                        name="model"
                                        value="レギュラーモデル"
                                        checked={selectedOption === "レギュラーモデル"}
                                        onChange={() => setSelectedOption("レギュラーモデル")}
                                    />
                                    レギュラーモデル
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="model"
                                        value="PPA モデル"
                                        checked={selectedOption === "PPA モデル"}
                                        onChange={() => setSelectedOption("PPA モデル")}
                                    />
                                    PPA モデル
                                </label>
                            </div>
                        </div>}

                    </div>



                </div>
                <div>
                    {showOptions ? <button className="submit-button" onClick={() => navigateTo()}>OK</button> : <button className="submit-button" onClick={() => handleShowOptions()}>開始</button>}

                </div>
            </div>
            <div className="col-md-12 footer"><Footer /></div>
        </div>
    );
}
export default Home;